import { render } from "./NormolipidicSummary.vue?vue&type=template&id=30d6764b"
import script from "./NormolipidicSummary.vue?vue&type=script&lang=js"
export * from "./NormolipidicSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__